import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pfnngursfedxzcruspcy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBmbm5ndXJzZmVkeHpjcnVzcGN5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYzNzM0OTIsImV4cCI6MjA1MTk0OTQ5Mn0.HOvyNjM9pu1Wo-hoiziWvtEtmHGImuNys4_Tq8Xg6-w";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);